export default __webpack_public_path__ + "static/media/ra-login.62909200.svg";